import isApiError from "@insite/client-framework/Common/isApiError";
import { get, post } from "@insite/client-framework/Services/ApiService";
import { SubscribedEmailDto } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";

export interface ApiResultModel {
    uri?: string;
    soaOrderStatusSummary?: {
        count?: number;
        isPrintPriceEnabled?: boolean;
    };
    subscribedEmails?: SubscribedEmailDto[];
    properties?: {
        [key: string]: string;
    };
}

export interface ApplySoaSubscriptionsApiResultModel {
    uri: string;
    customerId: string;
    isPrintPriceActive: string;
    subscribedEmails: SubscribedEmailDto [];
    properties: {
        [key: string]: string;
    };
}

const url = "/api/v1/soaSummary";

export async function getSoaSubscribers(customerId?: string) {
    const queryParams = customerId ? `?customerId=${customerId}` : "";
    try {
        const result = await get<ApiResultModel>(`${url}${queryParams}`, {}, {}, "no-store");
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}

export async function applySoaSubscriptionsService(
    customerId: string,
    subscribedEmails: SubscribedEmailDto[],
    isPrintPriceActive: boolean,
) {
    try {
        const result = await post<
            { customerId: string; subscribedEmails: SubscribedEmailDto[]; isPrintPriceActive: boolean },
            ApplySoaSubscriptionsApiResultModel
        >(`${url}`, {
            customerId,
            subscribedEmails,
            isPrintPriceActive,
        });

        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}
